export default {
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		nombre : {
			required : 'El campo nombre y apellidos es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		comunicaciones : {
			required : 'Debes aceptar el envio de comunicaciones'
		},
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js